import { Form, DatePicker } from "antd";
import React, { CSSProperties } from "react";

import "./FormItemDatePicker.scss";

interface FormItemDatePickerProps {
  dateFormat: string;
  name: string;
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  defaultValue?: string;
  disabled?: boolean;
  clearIcon?: boolean;
  style?: CSSProperties;
}

const FormItemDatePicker: React.FC<FormItemDatePickerProps> = ({
  dateFormat,
  name,
  placeholder,
  label,
  rules,
  defaultValue,
  disabled,
  clearIcon,
  style,
}) => {
  const svgIcon = (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.66699 2V5"
        stroke="#555555"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.333 2V5"
        stroke="#555555"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3333 3.5C18.5246 3.68 20.125 4.95 20.125 9.65V15.83C20.125 19.95 19.1667 22.01 14.375 22.01H8.625C3.83333 22.01 2.875 19.95 2.875 15.83V9.65C2.875 4.95 4.47542 3.69 7.66667 3.5H15.3333Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8851 17.6H3.11426"
        stroke="#555555"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5003 8.25C10.3216 8.25 9.32491 8.92 9.32491 10.22C9.32491 10.84 9.60283 11.31 10.0245 11.61C9.43991 11.97 9.10449 12.55 9.10449 13.23C9.10449 14.47 10.0149 15.24 11.5003 15.24C12.9762 15.24 13.8962 14.47 13.8962 13.23C13.8962 12.55 13.5607 11.96 12.9666 11.61C13.3978 11.3 13.6662 10.84 13.6662 10.22C13.6662 8.92 12.6791 8.25 11.5003 8.25ZM11.5003 11.09C11.002 11.09 10.6378 10.78 10.6378 10.29C10.6378 9.79 11.002 9.5 11.5003 9.5C11.9987 9.5 12.3628 9.79 12.3628 10.29C12.3628 10.78 11.9987 11.09 11.5003 11.09ZM11.5003 14C10.8678 14 10.4078 13.67 10.4078 13.07C10.4078 12.47 10.8678 12.15 11.5003 12.15C12.1328 12.15 12.5928 12.48 12.5928 13.07C12.5928 13.67 12.1328 14 11.5003 14Z"
        fill="#555555"
      />
    </svg>
  );

  return (
    <Form.Item
      style={style}
      className={`form-item__date-picker`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <DatePicker
        className={"date-picker"}
        placeholder={placeholder}
        disabled={disabled}
        suffixIcon={svgIcon}
        format={dateFormat}
        clearIcon={clearIcon}
      />
    </Form.Item>
  );
};

export default FormItemDatePicker;
